import { Component, inject, OnInit, signal } from '@angular/core';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { WorkProject, WorkProjectsV2Service } from '@work-frontend-monorepo/work-rest-api';
import { ProjekteDokumenteComponent } from '../../components/projekte-dokumente/projekte-dokumente.component';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';

@Component({
  selector: 'sfg-app-projekte-details-dokumente-page',
  templateUrl: './projekte-details-dokumente-page.component.html',
  styleUrls: ['./projekte-details-dokumente-page.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    ReactiveFormsModule,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonMenuButton,
    IonButtons,
    TranslatePipe,
    IonBackButton,
    ProjekteDokumenteComponent,
  ],
})
export class ProjekteDetailsDokumentePageComponent implements OnInit {
  project = signal<WorkProject | undefined>(undefined);

  private readonly exceptionHandlingService = inject(ExceptionHandlingService);
  private readonly workProjectsV2Service = inject(WorkProjectsV2Service);
  private readonly activatedRoute = inject(ActivatedRoute);

  async ngOnInit() {
    const projectId = this.activatedRoute.snapshot.params['projectId'];
    if (projectId) {
      await this.loadProjectDetails(projectId);
    }
  }

  private async loadProjectDetails(projectId: number) {
    try {
      const projectResponse = await lastValueFrom(
        this.workProjectsV2Service.projectsV2ControllerFindOneById({
          id: projectId,
          withAllDetails: true,
        }),
      );
      this.project.set(projectResponse);
    } catch (loadProjectException) {
      this.exceptionHandlingService.handleExceptionWithAlert('loadProjectException', loadProjectException);
    }
  }
}
